// extracted by mini-css-extract-plugin
export default {"statusIcon":"z4Qdy5MNZ8NAyGMismoFdw==","statusIcon12":"_9gDjdJJqaDWianwkZIAVzA==","statusIcon16":"_1buRBh2dhpIbsMz7fnwR7A==","statusIcon20":"inSng4ZMyUUL4lmbZCRBCg=="};